import styled from 'styled-components'
import { Units } from 'components/units'

export const Names = styled(Units)`
    flex-wrap: wrap;
    position: relative;
    left: -8px;
`